import * as React from 'react';

import classNames from 'classnames';

interface ITableProps {
	isFullWidth?: boolean;
	isStriped?: boolean;
	isHoverable?: boolean;
	isSelectable?: boolean;
	isBordered?: boolean;
	isNarrow?: boolean;
}

export default class Table extends React.Component<ITableProps, {}> {
	public render() {
		const {
			isBordered,
			isFullWidth,
			isStriped,
			isHoverable,
			isNarrow,
			isSelectable,
		} = this.props;

		const classes = classNames(
			'table',
			isFullWidth ? 'is-fullwidth' : '',
			isStriped ? 'is-striped' : '',
			isHoverable ? 'is-hoverable' : '',
			isSelectable ? 'is-selectable' : '',
			isBordered ? 'is-bordered' : '',
			isNarrow && 'is-narrow'
		);

		return <table className={classes}>{this.props.children}</table>;
	}
}
